import React from 'react'
import PropTypes from 'prop-types'
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  Bar
} from 'recharts'
import ChartLegend from '../ChartLegend/ChartLegend.component'
import renderTooltip from 'analytics/components/Chart/Tooltip/Tooltip.component'
import moment from 'moment'
import setChartColor from 'shared/utils/chart/setChartColor'

const renderChartLegend = parentProps => props => <ChartLegend {...parentProps} {...props} />

const CartesianChart = props => {
  const {
    resultSet,
    children,
    ChartComponent,
    dimensions
  } = props

  const data = resultSet.chartPivot()

  return (
    <ResponsiveContainer width='100%' height={500}>
      <ChartComponent data={props?.dataPreAggregator ? props.dataPreAggregator(data) : data}>
        <XAxis
          dataKey='x'
          tickFormatter={(label) => moment(label).format('MMM D')}
        />
        <YAxis />
        <CartesianGrid />
        { children }
        <Legend
          layout='vertical'
          verticalAlign='top'
          align='center'
          content={renderChartLegend(props)}
          dimensions={dimensions}
        />
        <Tooltip
          cursor={false}
          content={renderTooltip(props)}
        />
      </ChartComponent>
    </ResponsiveContainer>
  )
}

CartesianChart.propTypes = {
  resultSet: PropTypes.any,
  children: PropTypes.any,
  ChartComponent: PropTypes.any,
  dimensions: PropTypes.array,
  dataPreAggregator: PropTypes.func
}

const barRender = props => (
  <CartesianChart
    resultSet={props.resultSet}
    ChartComponent={BarChart}
    {...props}
  >
    {props.resultSet.seriesNames().map(series => (
      <Bar
        key={series.key}
        stackId="a"
        dataKey={series.key}
        name={series.title}
        fill={props?.customColorMapper ? props.customColorMapper(series.key) : setChartColor({
          type: props.dimensions,
          key: series.key
        })}
      />
    ))}
  </CartesianChart>
)
barRender.propTypes = {
  resultSet: PropTypes.object,
  chartType: PropTypes.string,
  granularity: PropTypes.string,
  dateRange: PropTypes.string,
  customDateRange: PropTypes.object,
  channelNameToFilter: PropTypes.string,
  onChangeChartType: PropTypes.func,
  onChangeGranularity: PropTypes.func,
  onMoveCustomDateRange: PropTypes.func,
  customColorMapper: PropTypes.func,
  dataPreAggregator: PropTypes.func,
  dimensions: PropTypes.array,
  tooltipDimension: PropTypes.string
}

export default barRender
